/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from 'relay-runtime';
declare export opaque type header_viewer$ref: FragmentReference;
export type header_viewer = {|
  +home_page: ?{|
    +header_posts: ?$ReadOnlyArray<?{|
      +title: string,
      +subtitle: string,
      +post_url: string,
      +image_url: string,
    |}>,
  |},
  +$refType: header_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "header_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "home_page",
      "storageKey": null,
      "args": null,
      "concreteType": "HomePageContent",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "header_posts",
          "storageKey": null,
          "args": null,
          "concreteType": "HomePagePost",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "subtitle",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "post_url",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "image_url",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node/*: any*/).hash = '2c5683cdc0b501df488ff5ea63e6384c';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/header_viewer.graphql.js